import {
  getActionsForContextUrl,
  getActionsUrl,
  getActionTypesUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class ActionService {
  static getActionTypes = () => {
    return getRequest(getActionTypesUrl()).then((actionTypes) => {
      return actionTypes;
    });
  };

  static deleteActionType = (actionTypeId) => {
    return deleteRequest(getActionTypesUrl() + "/" + actionTypeId);
  };

  static updateActionType = (actionTypeId, name) => {
    const param = { id: actionTypeId, name: name };
    return putRequest(getActionTypesUrl() + "/" + actionTypeId, param);
  };

  static createActionType = (name) => {
    const param = { name: name };
    return postRequest(getActionTypesUrl(), param);
  };

  static getActionsForContext = (contextId) => {
    return getRequest(getActionsForContextUrl() + "/" + contextId);
  };

  static createActionForContext = (newAction, contextId) => {
    return postRequest(getActionsForContextUrl() + "/" + contextId, newAction);
  };

  static updateAction = (action) => {
    return putRequest(getActionsUrl() + "/" + action.id, action);
  };

  static deleteAction = (actionId) => {
    return deleteRequest(getActionsUrl() + "/" + actionId);
  };
}
